import React, { createContext, useContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES } from "@highnote/server/src/sdk";

interface GenerateCommentsContextValue {
  selectedFile: File | null;
  setSelectedFile: (file: File | null) => void;
  selectedPersona: string;
  setSelectedPersona: (persona: string) => void;
  commentGenSessionId: string;
}

// This context is used to persist the user's selected file and persona across multiple steps in the Generate Comments flow,
// especially if the user needs to be redirected to authentication before continuing.

const GenerateCommentsContext = createContext<
  GenerateCommentsContextValue | undefined
>(undefined);

export const GenerateCommentsContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedPersona, setSelectedPersona] = useState<string>(
    CLIENT_CELEBRITY_DEMO_USER_SHORTNAMES.DAUBREY,
  );
  const [commentGenSessionId] = useState<string>(() => uuidv4());

  return (
    <GenerateCommentsContext.Provider
      value={{
        selectedFile,
        setSelectedFile,
        selectedPersona,
        setSelectedPersona,
        commentGenSessionId,
      }}
    >
      {children}
    </GenerateCommentsContext.Provider>
  );
};

export const useGenerateCommentsContext = () => {
  const context = useContext(GenerateCommentsContext);
  if (!context) {
    throw new Error(
      "useGenerateCommentsContext must be used within GenerateCommentsContextProvider",
    );
  }
  return context;
};
